var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"projects-overview"},[_c('about'),_vm._l((_vm.projects),function(p){return _c('div',{key:p.id},[_c('overview-project',{attrs:{"project-id":p.id,"project-slug":p.slug}})],1)})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }